import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'ev-messageSend': this.onMessageSend,
        'fileView': 'media',
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};